define([
	"csi/_base/underscore",
	"csi/def/ActionFactory",
	"csi/reflection",
	"csi/xml",
	"./_StateAction"
], function(_,ActionFactory,reflection,xml,_StateAction) {

	return ActionFactory.declare("ReopenPhase", _StateAction, {
		_bLatestRevision: false,
		m_tag: "ReopenPhase",

		_hasStateAccess: function(/*Context*/ctx, /*Node*/master, /*Node*/revision) {
			// summary: allow reopen only on previous revisions with phase less than or equal to current phase;
			// if no phases, then allow action if we have gotten this far
			if (!this.inherited(arguments)) {
				return false;
			}

			var	currentRevision = ctx.cache.getNode(master.CurrentRevision);
			var	phases = reflection.getClassConfig(master.$Type).getPhases();
			if (phases) {
				var	urls = _.map(phases, function(p) { return p.$URL; });

				if (_.indexOf(urls, revision.Phase) > _.indexOf(urls, currentRevision.Phase)) {
					return false;
				}
			}

			if (revision.$Type == "SupplierItemRevision" || revision.$Type == "SpecificationDataSheetSupplierResponseRevision") { // DE26669
				// S11593,C8-1004 SupplierItem: cannot reopen the latest revision if it is already in draft state.
				// If it is in any other state, the check will be done on the server by role.
				var	latestRevision = ctx.cache.getNode(master.LatestRevision);

				if (latestRevision.State == reflection.REVISION_DRAFT)
					return revision != latestRevision;
			}

			return true;
		}
	});
});